import e from "@dialpad/dialtone-tokens/layered/themes/tokens-botany-colors.css?inline";
//#region themes/botany.js
var t = { brand: {
	css: e,
	name: "botany"
} };
//#endregion
export { t as default };
